<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Playlist bearbeiten">
      <video-category-form
        :loading="loading"
        :category="category"
        :form-submitted="saveCategory"
        mode="edit"
      ></video-category-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import VideoCategoryForm from "@/components/forms/VideoCategoryForm"
import VideoCategoriesRepository from "@/repositories/video_categories_repository.js"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

export default {
  metaInfo: {
    title: "Playlist bearbeiten"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    VideoCategoryForm
  },
  mixins: [ApiErrorHandlerMixin],
  data() {
    return {
      loading: true,
      category: {}
    }
  },
  async created() {
    try {
      this.category = await VideoCategoriesRepository.get(this.$route.params.id)
      this.loading = false
    } catch (error) {
      this.loading = false
      this.handleApiError(error)
    }
  },
  methods: {
    async saveCategory(category) {
      await VideoCategoriesRepository.update(category.id, category)
      this.$router.push({ name: "VideoCategoriesPage" })
    }
  }
}
</script>
